<div class="container" *ngIf="!plan">
  <mat-icon svgIcon="mat:close" class="close-icon" *ngIf="closeBtnTop" (click)="closeModal()"></mat-icon>
  <!-- <ion-icon *ngIf="icon" [name]="icon" [ngClass]="iconClass ? iconClass : ''"></ion-icon> -->
  <h1 class="text-center">{{title}}</h1>
  <p class="text-center" *ngIf="date">{{date}}</p>
  <p class="text-center sub-title-popup">{{subTitle}}</p>
  <div *ngIf="customHtml" [innerHTML]="customHtml"></div>

  <p *ngIf="showPortalLink" (click)="closeModal('openPortal')" class="portal-link">{{"LOGIN.REACTIVATE-PLAN.PORTAL" | translate}}</p>
  <div class="footer-position">
    <button class="its-button" *ngIf="callbackBtn" (click)="closeModal(callbackBtn)">{{buttonTitle}}</button>
    <button class="its-button" *ngIf="redirectUrl" (click)="closeModal()">{{buttonTitle}}</button>
    <button class="its-button" *ngIf="!redirectUrl && !closeBtnTop" (click)="closeModal()">{{"GENERIC.CLOSE" | translate}}</button>
  </div>
</div>
<div class="container" *ngIf="plan">
  <mat-icon svgIcon="mat:close" class="close-icon" (click)="closeModal()"></mat-icon>
  <h1>
    <img src="../../assets/img/thunderbolt_outline_violet.svg" alt="">
    {{plan.type}}</h1>
  <p #planDescriptionHTML [innerHTML]="plan.description"></p>
</div>
